const React = require('react');

module.exports = ({children, cellRef, className, ...props}) => (
  <div
    {...props}
    ref={cellRef}
    className={
      `rlv h45 layoutRow jcC aiC pt13 pb14 f12 lh18 bg3E4044 cF tc bh1 bshSolid bcr2C2D30 bcl73757A 
      (rlt9|bcl3E4044):first-child (bcr3E4044|rrt9):last-child`
      + (className ? ` ${className}` : '')
    }
  >
    {children}
  </div>
)
